import { getSiteOrigin } from '@utils/config';

import { toAbsoluteUrl } from './toAbsoluteUrl';

export const DEFAULT_OG_IMAGE_PATH = '/layta-logo-horizontal.jpg';
export const DEFAULT_OG_IMAGE_TYPE = 'image/jpeg';
/** Telegram / Open Graph recommended share size */
export const DEFAULT_OG_IMAGE_WIDTH = 1200;
export const DEFAULT_OG_IMAGE_HEIGHT = 630;

/**
 * Absolute OG image URL.
 * Prefer request/browser origin over NEXT_PUBLIC_FRONTEND_DOMAIN so preview deploys
 * (e.g. sl-364-*) don't point og:image at the base host that may not have the asset yet.
 */
export const resolveOgImageUrl = (image?: string | null, requestOrigin?: string | null): string | undefined => {
    const trimmed = image?.trim();
    const pathOrUrl = trimmed || DEFAULT_OG_IMAGE_PATH;

    if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) {
        return pathOrUrl;
    }

    const origin =
        requestOrigin?.replace(/\/$/, '') ||
        (typeof window !== 'undefined' ? window.location.origin : '') ||
        getSiteOrigin();

    if (!origin) {
        return undefined;
    }

    return toAbsoluteUrl(origin, pathOrUrl);
};

export const isDefaultOgImage = (image?: string | null): boolean => !image?.trim();
